import HeroSlider from "@/components/feature/HeroSlider";
import NewsTicker from "@/components/feature/NewsTicker";
import BioconToday from "@/components/feature/BioconToday";
import BioconNews from "@/components/feature/BioconNews";
import PartnerBanners from "@/components/feature/PartnerBanners";
import GovPartners from "@/components/feature/GovPartners";
import AlliancePartners from "@/components/feature/AlliancePartners";
import BioconFooter from "@/components/feature/BioconFooter";
import ScrollReveal from "@/components/base/ScrollReveal";

export default function Home() {
  return (
    <>
      <HeroSlider />
      <NewsTicker />

      {/* Biocon Today + Biocon News */}
      <section className="py-12 bg-[#f6f9fc]">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row lg:items-stretch gap-10">
            {/* Biocon Today */}
            <div className="w-full lg:w-3/5 flex">
              <BioconToday />
            </div>
            {/* Biocon News */}
            <div className="w-full lg:w-2/5 flex">
              <BioconNews />
            </div>
          </div>
        </div>
      </section>

      <ScrollReveal delay={0.1}>
        <PartnerBanners />
      </ScrollReveal>

      <ScrollReveal delay={0.1}>
        <GovPartners />
      </ScrollReveal>

      <ScrollReveal delay={0.1}>
        <AlliancePartners />
      </ScrollReveal>

      <BioconFooter />
    </>
  );
}
